import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Alert from 'antd/lib/alert';
import { TextField } from '@ackee/mateus';

import { FormattedMessage, useIntl } from 'react-intl';
import Tabs from 'antd/lib/tabs';

import { EditorField } from 'modules/forms';
import config from 'config/index';

const TabPane = Tabs.TabPane;

const InfoForm = ({ handleSubmit, submitting, error }) => {
    const intl = useIntl();
    return (
        <form onSubmit={handleSubmit}>
            <h3>
                <FormattedMessage id="form.section.translations" />
            </h3>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <Tabs>
                {config.app.languages.map(lang => (
                    <TabPane tab={<FormattedMessage id={`languages.${lang}`} />} key={lang}>
                        <TextField
                            name={`${lang}.title`}
                            label={intl.formatMessage({ id: `info.add.form.title.label` })}
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                        <EditorField
                            name={`${lang}.body`}
                            label={intl.formatMessage({ id: `info.add.form.body.label` })}
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                    </TabPane>
                ))}
            </Tabs>
            <Button type="primary" htmlType="submit" loading={submitting}>
                <FormattedMessage id="info.add.form.submit" />
            </Button>
        </form>
    );
};

InfoForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,

    error: PropTypes.string,
};

InfoForm.defaultProps = {
    error: null,
};

export default InfoForm;
